import type { FC } from "react";

import { faPencil } from "@fortawesome/pro-duotone-svg-icons/faPencil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MenuItemLink } from "./menu_item_link";

export const MenuItemLinkEdit: FC<{
  to: string;
}> = ({ to }) => (
  <MenuItemLink to={to}>
    <FontAwesomeIcon icon={faPencil} /> Edit
  </MenuItemLink>
);
